import { setAlert } from "./alert";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";

import { firebase } from "../firebase";
import { getAuth } from "firebase/auth";
import {
  ADD_MODULE,
  ADD_TEAM_INFO,
  ADD_TEAM_LEAD_INFO,
  MODULE_ERROR,
  TEAM_ERROR,
  TEAM_LEAD_ERROR,
} from "./types";

const auth = getAuth(firebase);
const db = getFirestore(firebase);

export const registerTeamLead = (formData) => async (dispatch) => {
  try {
    const res = auth.currentUser;

    const docRef = doc(db, "teamLead", res.uid);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      await setDoc(doc(db, "teamLead", res.uid), {
        uid: res.uid,
        ...formData,
      });
    }
    dispatch({
      type: ADD_TEAM_LEAD_INFO,
      payload: {
        data: formData,
      },
    });
    return true;
  } catch (error) {
    dispatch(setAlert(error.message, "danger"));
    dispatch({
      type: TEAM_LEAD_ERROR,
    });
  }
};

export const registerTeamInfo = (formData) => async (dispatch) => {
  try {
    const res = auth.currentUser;

    const teamLeadDocRef = doc(db, "teamLead", res.uid);
    const teamLeaddocSnap = await getDoc(teamLeadDocRef);

    if (teamLeaddocSnap.exists()) {
      const docRef = doc(db, "teamMember", res.uid);
      const docSnap = await getDoc(docRef);
      if (!docSnap.exists()) {
        await setDoc(doc(db, "teamMember", res.uid), {
          uid: res.uid,
          ...formData,
        });
      }
      dispatch({
        type: ADD_TEAM_INFO,
        payload: {
          data: formData,
        },
      });
      return true;
    } else {
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: TEAM_ERROR,
      });
    }
  } catch (error) {
    dispatch(setAlert(error.message, "danger"));
    dispatch({
      type: TEAM_ERROR,
    });
  }
};

export const getTeamLeadData = () => async (dispatch) => {
  try {
    console.log("runggin");
    const res = auth.currentUser;

    const teamLeadDocRef = doc(db, "teamLead", res.uid);
    const teamLeaddocSnap = await getDoc(teamLeadDocRef);

    if (teamLeaddocSnap.exists()) {
      const teamLeadData = teamLeaddocSnap.data();
      return teamLeadData;
    }
    return null;
  } catch (error) {
    dispatch(setAlert(error.message, "danger"));
    dispatch({
      type: TEAM_LEAD_ERROR,
    });
  }
};

export const getTeamMemberData = () => async (dispatch) => {
  try {
    const res = auth.currentUser;

    const teamMemberDocRef = doc(db, "teamMember", res.uid);
    const teamMemberdocSnap = await getDoc(teamMemberDocRef);

    if (teamMemberdocSnap.exists()) {
      const teamMemberData = teamMemberdocSnap.data();
      return teamMemberData;
    }
    return null;
  } catch (error) {
    dispatch(setAlert(error.message, "danger"));
    dispatch({
      type: TEAM_LEAD_ERROR,
    });
  }
};

export const addTeamModules = (formData) => async (dispatch) => {
  try {
    const res = auth.currentUser;

    const teamLeadDocRef = doc(db, "teamLead", res.uid);
    const teamLeaddocSnap = await getDoc(teamLeadDocRef);

    if (teamLeaddocSnap.exists()) {
      const docRef = doc(db, "module", res.uid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        await setDoc(doc(db, "module", res.uid), {
          uid: res.uid,
          ...formData,
        });
      }
    } else {
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: MODULE_ERROR,
      });
    }
    dispatch({
      type: ADD_MODULE,
      payload: {
        data: formData,
      },
    });

    return true;
  } catch (error) {
    dispatch(setAlert(error.message, "danger"));
    dispatch({
      type: MODULE_ERROR,
    });
  }
};

export const getTeamModules = () => async (dispatch) => {
  try {
    const res = auth.currentUser;

    const docRef = doc(db, "teamMember", res.uid);
    const docSnap = await getDoc(docRef);

    if (docRef.exists()) {
      const modulesData = docSnap.data();

      return modulesData;
    }
    return null;
  } catch (error) {
    dispatch(setAlert(error.message, "danger"));
    dispatch({
      type: MODULE_ERROR,
    });
  }
};
